export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00627.bf950f69.png";